import instance from "@/services/api";

export const wcheckBpmnAPI = {
  async getSchemaEditAccess() {
    return await instance()
      .get("/project/wcheck_bpmn/schema-edit-access/read/")
      .then((res) => res?.data);
  },

  async getSchemas() {
    return await instance()
      .get("/project/wcheck_bpmn/schemas/read/")
      .then((res) => res?.data);
  },

  async duplicateSchema(body) {
    return await instance()
      .post("/project/wcheck_bpmn/schemas/duplicate/", body)
      .then((res) => res?.data);
  },

  async getDicts() {
    return await instance()
      .get("/project/wcheck_bpmn/dicts/read/")
      .then((res) => res?.data);
  },

  async getNodes(schemaId) {
    return await instance()
      .get("/project/wcheck_bpmn/nodes/read/", { params: { schema_id: schemaId } })
      .then((res) => res?.data);
  },

  async getEdges(schemaId) {
    return await instance()
      .get("/project/wcheck_bpmn/edges/read/", { params: { schema_id: schemaId } })
      .then((res) => res?.data);
  },

  async getProcessInstances() {
    return await instance()
      .get("/project/wcheck_bpmn/process/instances/read/")
      .then((res) => res?.data);
  },

  async getInstanceByKeys(workSetCheckGroupId, floorMapId, placementTypeId) {
    return await instance()
      .get("/project/wcheck_bpmn/process/instance/get-by-keys/", {
        params: {
          work_set_check_group_id: workSetCheckGroupId,
          floor_map_id: floorMapId,
          placement_type_id: placementTypeId,
        },
      })
      .then((res) => res?.data);
  },

  async getInstanceNodes(processInstanceId) {
    return await instance()
      .get("/project/wcheck_bpmn/process/instance-nodes/read/", {
        params: { process_instance_id: processInstanceId },
      })
      .then((res) => res?.data);
  },

  async fireEvent(data) {
    return await instance()
      .post("/project/wcheck_bpmn/process/fire-event/", data)
      .then((res) => res?.data);
  },

  async updateNodePosition(bpmnNodeId, posX, posY) {
    return await instance()
      .post("/project/wcheck_bpmn/node/position/update/", {
        bpmn_node_id: bpmnNodeId,
        pos_x: posX,
        pos_y: posY,
      })
      .then((res) => res?.data);
  },

  async createNode(data) {
    return await instance()
      .post("/project/wcheck_bpmn/node/create/", data)
      .then((res) => res?.data);
  },

  async updateNode(data) {
    return await instance()
      .post("/project/wcheck_bpmn/node/update/", data)
      .then((res) => res?.data);
  },

  async deleteNode(bpmnNodeId) {
    return await instance()
      .post("/project/wcheck_bpmn/node/delete/", { bpmn_node_id: bpmnNodeId })
      .then((res) => res?.data);
  },

  async createEdge(data) {
    return await instance()
      .post("/project/wcheck_bpmn/edge/create/", data)
      .then((res) => res?.data);
  },

  async updateEdge(data) {
    return await instance()
      .post("/project/wcheck_bpmn/edge/update/", data)
      .then((res) => res?.data);
  },

  async deleteEdge(bpmnEdgeId) {
    return await instance()
      .post("/project/wcheck_bpmn/edge/delete/", { bpmn_edge_id: bpmnEdgeId })
      .then((res) => res?.data);
  },

  async createTaskType(data) {
    return await instance().post("/project/wcheck_bpmn/task-type/create/", data).then((r) => r?.data);
  },
  async updateTaskType(data) {
    return await instance().post("/project/wcheck_bpmn/task-type/update/", data).then((r) => r?.data);
  },
  async deleteTaskType(taskTypeId) {
    return await instance().post("/project/wcheck_bpmn/task-type/delete/", { task_type_id: taskTypeId }).then((r) => r?.data);
  },

  async createAutoAction(data) {
    return await instance().post("/project/wcheck_bpmn/auto-action/create/", data).then((r) => r?.data);
  },
  async updateAutoAction(data) {
    return await instance().post("/project/wcheck_bpmn/auto-action/update/", data).then((r) => r?.data);
  },
  async deleteAutoAction(id) {
    return await instance().post("/project/wcheck_bpmn/auto-action/delete/", { bpmn_auto_action_id: id }).then((r) => r?.data);
  },
};
